export const translations = {
  en: {
    // Home page
    homeTitle: "We're getting married! ❤️🦆",
    homeDate: '12. September 2026, 6:00 pm',
    homeLocation:
      '📍Schilling Roofbar, Alte Glockengießerei 9, 69115 Heidelberg',
    homeDressCode: '👗👠 Dress Code: Cocktail / Semi-formal / Festive',
    homeInfo:
      "❣️Please be advised that we won't send out invitation cards. All relevant information can be found on this page and you will also find the photos from our wedding day here later. Please make sure to RSVP above by",
    homeRsvpDate: ' July 31st, 2026. ',
    homeUpdateUs: 'In case there are any changes kindly update us',
    homeViaEmail: ' via Email',
    homeCelebrate: ". We can't wait to celebrate with you! 💕",

    rsvpButton: 'RSVP',

    // Navigation
    navHome: 'Home',
    navHotels: 'Hotels',
    navHeidelberg: 'Heidelberg',
    navGifts: 'Gifts',
    navContact: 'Contact Us',

    // Hotels page
    hotelsTitle: 'Where to Stay',
    hotelsIntro:
      "In case you need a hotel, below you can find some hotels we'd recommend close enough to the venue. We hope you enjoy your time in Heidelberg!",
    weddingVenueBadge: '💒 Wedding Venue',
    viewWebsite: 'View Website →',

    // Heidelberg page
    heidelbergTitle: 'Welcome to Heidelberg',
    heidelbergIntro:
      "Heidelberg has been our chosen home for the last few years and it's also the place we met and fell in love❣️",
    heidelbergDescription:
      "With it's beautiful castle ruins and charming little old town it's definitely a romantic place.",
    heidelbergCall:
      "In case you're coming from afar and have a few days to spend here, below you can find a selection of ToDos and some of our favourite places to go, eat and drink!🍽️🍹",
    heidelbergClosing: "We hope you'll enjoy your time here!",
    heidelbergSignature: 'Love, Christoph & Franzi',
    heidelbergRestaurants: 'Best Bars and Restaurants in Heidelberg',
    heidelbergWhatElseToDo: 'Must Sees in Heidelberg',

    // Must Sees content
    castleHikeText: 'Checkout ',
    castleHikeLink: 'this hike',
    castleHikeEnd: ' with the best view of the castle.',
    castleShorterText: 'Or for a shorter round check out ',
    castleShorterLink: 'this route.',
    castleWebsite: 'Schloss Heidelberg',
    koenigstuhlText: 'Checkout ',
    koenigstuhlLink: 'this hike',
    koenigstuhlEnd: ' from the Altstadt.',
    koenigstuhlWebsite: 'Königstuhl',
    altstadtWebsite: 'Altstadt Heidelberg',

    // Gifts page
    giftsTitle: 'Wedding Gifts',
    giftsIntro:
      'Your presence at our wedding is of course the best gift of all! However, if you wish to honour us with a gift, we would be grateful for a contribution towards our future together.',
    giftsCardTitle: 'Send a Gift via PayPal',
    giftsCardDescription:
      'You can send your gift securely through PayPal using the button below: ',
    giftsButton: 'Send Gift via PayPal',
    giftsFooter:
      "Thank you for your kindness and generosity! We can't wait to celebrate with you. Please keep in mind that we find digital payments more convenient than physical gifts 😉",
    giftsSignature: 'Love, Christoph & Franzi',

    // Contact page
    contactTitle: 'Got questions?',
    contactSubtitle: "We're here to help with any questions you might have!",
    contactButton: 'Please get in touch!',
    contactPromise: "We promise we'll get back to you as quickly as possible.",

    // RSVP Modal
    rsvpTitle: 'RSVP',
    rsvpNamePlaceholder: 'Please enter your name',
    rsvpEmailPlaceholder: 'Email address',
    rsvpPlusOne: "I'm bringing a Plus One",
    rsvpPlusOnePlaceholder: 'Plus One name',
    rsvpPlusOneDietary: "Plus One's Dietary Preferences",
    rsvpDietaryPreferences: 'Dietary Preferences',
    rsvpVegetarian: 'Vegetarian',
    rsvpVegan: 'Vegan',
    rsvpNoDietaryRestrictions: 'No dietary restrictions',
    rsvpCommentsPlaceholder:
      'Food allergies or any other comments? Let us know here!',
    rsvpSubmit: 'Send RSVP',
    rsvpErrorName: 'Please enter your name',
    rsvpErrorEmailRequired: 'Please enter your email address',
    rsvpErrorEmailInvalid: 'Please enter a valid email address',
    rsvpErrorPlusOne: "Please enter your plus one's name",
    rsvpErrorDietary: 'Please select a dietary preference',
  },
  de: {
    // Home page
    homeTitle: 'Wir heiraten! ❤️🦆',
    homeDate: '12. September 2026, 18:00 Uhr',
    homeLocation:
      '📍Schilling Roofbar, Alte Glockengießerei 9, 69115 Heidelberg',
    homeDressCode: '👗👠 Dresscode: Cocktail / Semi-formal / Festlich',
    homeInfo:
      '❣️Bitte beachtet, dass wir keine offiziellen Einladungskarten verschicken. Alle wichtigen Informationen findet ihr auf dieser Website. Nach der Hochzeit werdet ihr hier auch die Fotogalerie finden. Bitte gebt uns oben bis zum ',
    homeRsvpDate: ' 31. July 2026 ',
    homeUpdateUs:
      'Bescheid, ob ihr kommt. Falls sich bei euch etwas ändert, informiert uns bitte',
    homeViaEmail: ' per E-Mail',
    homeCelebrate: '. Wir freuen uns darauf, mit euch zu feiern! 💕',

    rsvpButton: 'Zusagen',

    // Navigation
    navHome: 'Start',
    navHotels: 'Hotels',
    navHeidelberg: 'Heidelberg',
    navGifts: 'Geschenke',
    navContact: 'Kontakt',

    // Hotels page
    hotelsTitle: 'Übernachtungsmöglichkeiten',
    hotelsIntro:
      'Falls ihr eine Unterkunft braucht, findet ihr hier einige Hotels, die wir empfehlen können und die nah genug an der Location sind. Wir hoffen, ihr genießt eure Zeit in Heidelberg!',
    weddingVenueBadge: '💒 Hochzeitslocation',
    viewWebsite: 'Zur Webseite →',

    // Heidelberg page
    heidelbergTitle: 'Willkommen in Heidelberg',
    heidelbergIntro:
      'Heidelberg ist seit einigen Jahren unsere Heimat und auch der Ort, an dem wir uns kennen und lieben gelernt haben ❣️',
    heidelbergDescription:
      'Mit seinen wunderschönen Schlossruinen und der charmanten Altstadt ist es definitiv ein romantischer Ort.',
    heidelbergCall:
      'Falls ihr von weiter her kommt und ein paar Tage Zeit habt, findet ihr unten eine Auswahl an Aktivitäten und unsere Lieblingsorte zum Essen und Trinken! 🍽️🍹',
    heidelbergClosing: 'Wir hoffen, ihr genießt eure Zeit hier!',
    heidelbergSignature: 'Christoph & Franzi',
    heidelbergRestaurants: 'Die besten Bars und Restaurants in Heidelberg',
    heidelbergWhatElseToDo: 'Must-Sees in Heidelberg',

    // Must Sees content
    castleHikeText: 'Wir empfehlen ',
    castleHikeLink: 'diese Wanderung',
    castleHikeEnd: ' für die beste Aussicht auf das Schloss.',
    castleShorterText: 'Oder für eine kürzere Runde ',
    castleShorterLink: 'diese Route.',
    castleWebsite: 'Schloss Heidelberg',
    koenigstuhlText: 'Wir empfehlen ',
    koenigstuhlLink: 'diese Wanderung',
    koenigstuhlEnd: ' von der Altstadt aus.',
    koenigstuhlWebsite: 'Königstuhl',
    altstadtWebsite: 'Altstadt Heidelberg',

    // Gifts page
    giftsTitle: 'Hochzeitsgeschenke',
    giftsIntro:
      'Eure Anwesenheit bei unserer Hochzeit ist natürlich das schönste Geschenk! Falls ihr uns dennoch mit einem Geschenk ehren möchtet, würden wir uns über einen Beitrag für unsere gemeinsame Zukunft freuen.',
    giftsCardTitle: 'Geschenk per PayPal senden',
    giftsCardDescription:
      'Ihr könnt euer Geschenk ganz einfach und sicher über PayPal senden:',
    giftsButton: 'Geschenk per PayPal senden',
    giftsFooter:
      'Vielen Dank für eure Großzügigkeit! Wir freuen uns darauf, mit euch zu feiern. Bitte beachtet, dass uns digitale Zahlungen lieber sind als physische Geschenke 😉',
    giftsSignature: 'Alles Liebe, Christoph & Franzi',

    // Contact page
    contactTitle: 'Fragen?',
    contactSubtitle: 'Wir helfen euch gerne bei allen Fragen weiter!',
    contactButton: 'Schreibt uns!',
    contactPromise: 'Wir melden uns so schnell wie möglich bei euch.',

    // RSVP Modal
    rsvpTitle: 'Zusage',
    rsvpNamePlaceholder: 'Bitte gib deinen Namen ein',
    rsvpEmailPlaceholder: 'E-Mail-Adresse',
    rsvpPlusOne: 'Ich bringe eine Begleitung mit',
    rsvpPlusOnePlaceholder: 'Name der Begleitung',
    rsvpPlusOneDietary: 'Essensvorlieben der Begleitung',
    rsvpDietaryPreferences: 'Essensvorlieben',
    rsvpVegetarian: 'Vegetarisch',
    rsvpVegan: 'Vegan',
    rsvpNoDietaryRestrictions: 'Keine Einschränkungen',
    rsvpCommentsPlaceholder:
      'Lebensmittelallergien oder sonstige Anmerkungen? Schreibt es uns hier!',
    rsvpSubmit: 'Zusage senden',
    rsvpErrorName: 'Bitte gib deinen Namen ein',
    rsvpErrorEmailRequired: 'Bitte gib deine E-Mail-Adresse ein',
    rsvpErrorEmailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    rsvpErrorPlusOne: 'Bitte gib den Namen deiner Begleitung ein',
    rsvpErrorDietary: 'Bitte wähle eine Essenspräferenz aus',
  },
};

export function getLanguage() {
  const browserLang = navigator.language || navigator.userLanguage;
  return browserLang.startsWith('de') ? 'de' : 'en';
}
